import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Milestone, MilestoneCard } from 'src/app/core/models/project-pilot.model';
import { Context } from 'src/app/shared/models/context';
import { PrivilegeType } from 'src/app/shared/models/domain';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DataService } from 'src/app/shared/services/data.service';
import { ProjectPilotService } from 'src/app/shared/services/project-pilot.service';
import { ManageMilestoneComponent } from '../milestone/manage-milestone/manage-milestone.component';

@Component({
  selector: 'app-milestone-insight',
  templateUrl: './milestone-insight.component.html',
  styleUrls: ['./milestone-insight.component.scss']
})
export class MilestoneInsightComponent implements OnInit {
  public milestones: Milestone[] = [];
  public isLoading: boolean = true;
  public count = 3;
  public employeeCount!: number;
  public milestoneCard: MilestoneCard;
  public privilege: PrivilegeType;
  public context: Context;
  private subscription: any;


  constructor(
    private projectPilotService: ProjectPilotService,
    private commonService: CommonService,
    private authService: AuthService,
    private dataService: DataService,
    private modalService: NgbModal

  ) { }

  ngOnInit(): void {
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
    this.subscription = this.authService.getContext().subscribe(context => {
      this.context = context;
      if (context.milestoneId) {
        this.getMilestoneCard();
      }
    });
    this.getMilestonenInsights();
  }

  public getMilestonenInsights() {
    this.projectPilotService.getMilestoneInsights(this.count).subscribe({
      next: (milestone: Milestone[]) => {
        this.milestones = milestone;
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.commonService.setToastr(500, error?.error?.name || error.error);
        this.isLoading = false;
      }
    });
  }

  public getMilestoneCard() {
    this.projectPilotService.getMilestoneCard(this.context.teamId).subscribe({
      next: (milestone: MilestoneCard) => {
        this.milestoneCard = milestone;
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.commonService.setToastr(500, error?.error?.name || error.error);
        this.isLoading = false;
      }
    });
  }

  public createMilestone(milestone?: Milestone) {
    if (!this.privilege.canEdit) return;
    const modalRef = this.modalService.open(ManageMilestoneComponent, { size: 'xl', backdrop: 'static' });
    modalRef.componentInstance.milestone = milestone;
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
